import React from "react";
import { WEEK_DAYS } from "../../../constants/EventConstants";
import { getStatusColor } from "../../../helpers/EventHelpers";
import { getCompanyFormatTime } from "../../../helpers/DateUtils";

export interface Props {
  calendarDays: DayCell[];
  isToday: (date: Date) => boolean;
  handleEventClick: (event: PublicEvent) => void;
}

export const EventsContent: React.FC<Props> = ({ calendarDays, isToday, handleEventClick }) => {
  return (
    <div className="events-calendar">
      <div className="events-week-header">
        {WEEK_DAYS.map((day) => (
          <div key={day} className="events-week-day">
            {day}
          </div>
        ))}
      </div>
      <div className="events-days-grid">
        {calendarDays.map((day, index) => (
          <div
            key={index}
            className={`events-day-cell${!day.isCurrentMonth ? " other-month" : ""}${
              isToday(day.date) ? " today" : ""
            }`}
          >
            <div className="events-day-number">{day.date.getDate()}</div>
            <div className="events-container">
              {day.events.slice(0, 3).map((event) => (
                <button
                  key={event.id}
                  className="events-event-item"
                  style={{ backgroundColor: getStatusColor(event) }}
                  onClick={() => handleEventClick(event)}
                  title={`${event.eventName} - ${event.status?.name || "Planned"}`}
                >
                  <span className="events-event-time text-uppercase">
                    {getCompanyFormatTime(new Date(event.startTime))}&minus;
                    {getCompanyFormatTime(new Date(event.endTime))}
                  </span>
                  <span className="events-event-name">{event.eventName}</span>
                </button>
              ))}
              {day.events.length > 3 && (
                <div className="events-more-events">+{day.events.length - 3} more</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
